import { Box } from '@mui/material'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useSWR from 'swr'

import { operations } from '~/api'
import { AnalyticsCard, AnalyticsStockCard } from '~/src/components/molecules'
import { LoadingDashboard } from '~/src/components/organisms/Loading/LoadingDashboard'
import { useMessage } from '~/src/hooks'
import { formatNumber } from '~/src/libs'
import { dashBoardRepository } from '~/src/repositories'
import { IDashBoardResponse } from '~/src/repositories/DashBoard/models/DashBoard'

type ApiParams = operations['getDashboardItem']
type ApiResponse = operations['getDashboardItem']['responses']['200']['content']['application/json']

/**
 * Analytics
 * @constructor
 */
export const Analytics: React.VFC = () => {
  const { t } = useTranslation()
  const { handleOpenWithErrorMessage } = useMessage()
  const { data, error } = useSWR(['/dashboard'], () => dashBoardRepository.getDashboardItem())

  useEffect(() => {
    if (error) handleOpenWithErrorMessage(error)
  }, [error])

  if (!data) return <LoadingDashboard />

  const item: IDashBoardResponse['data'] = data.data

  return (
    <Box sx={{ display: 'grid', gap: 4, gridTemplateColumns: 'repeat(3, 1fr)' }}>
      <AnalyticsStockCard
        label={t('dashboard.listed_stock_count')}
        title={t('dashboard.vehicle')}
        count={Number(formatNumber(item.stockCarsCount))}
        units={t('dashboard.units')}
        comparisonText={t('dashboard.change_from_previous_day')}
        comparisonDiff={item.stockCarsDiff}
        updatedAt={item.stockUpdatedAt}
      />
      <AnalyticsCard label={t('dashboard.number_of_registered_users')} units={t('dashboard.people')} count={formatNumber(item.usersCount)} />
      <AnalyticsStockCard
        label={t('dashboard.listed_stock_count')}
        title={t('dashboard.engine')}
        count={Number(formatNumber(item.stockEnginesCount))}
        units={t('dashboard.units')}
        comparisonText={t('dashboard.change_from_previous_day')}
        comparisonDiff={item.stockEnginesDiff}
        updatedAt={item.stockUpdatedAt}
      />
      <AnalyticsCard
        label={t('dashboard.todays_contact_order_count')}
        units={t('dashboard.orders')}
        count={item.requestOrdersCount}
      />
    </Box>
  )
}
